import { Input as ThemeUIInput, InputProps } from '@apia/theme';
import { IFieldDefinition } from '../../../types';
import Wrapper from './Wrapper';
import useValidateField from './useValidateField';
import { ICustomValidate } from './types';

type TInput = InputProps & {
  autocomplete?: 'on' | 'off';
  label: string;
  name: string;
  tooltip: string;
  validations: IFieldDefinition['validate'];
  submitValueParser?: ICustomValidate<string, string>['submitValueParser'];
};

const Input = ({
  label,
  name,
  validations,
  tooltip,
  submitValueParser,
  ...props
}: TInput) => {
  const { value, onChange } = useValidateField<string>({
    name,
    validations,
    initialValue: '',
    submitValueParser,
  });

  return (
    <Wrapper
      {...{
        validations,
        name,
        label,
        tooltip,
        className: `input ${props.className ?? ''}`,
      }}
    >
      <ThemeUIInput
        name={name}
        autoComplete={props.autocomplete ?? 'off'}
        onChange={(ev) => onChange({ value: ev.target.value })}
        value={value ?? ''}
        {...props}
      />
    </Wrapper>
  );
};

export default Input;
